export default __webpack_public_path__ + "static/media/ri-eye-fill.0b7fbc4a.svg";